import React, { useState } from "react";
import { Compare } from "../common/slider";

function Transform() {
  const [activeTransform, setActiveTransform] = useState(1);

  const handleChooseTransform = (index: number) => {
    setActiveTransform(index);
  };

  return (
    <>
      <section className="px-6 pb-6 lg:px-24 lg:pb-12 flex flex-col gap-6">
        <div className="w-full bg-gray-100 rounded-xl p-6 flex flex-col gap-6">
          <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between">
            <div className="flex flex-col items-start justify-start gap-2 text-left mb-4">
              <h2 className="uppercase color-yellow text-xl">Transformacje</h2>
              <h3 className="text-3xl lg:text-5xl color-green">
                Zobacz jak odmieniamy{" "}
                <span className="color-yellow">ogrody</span>
              </h3>
            </div>
            <a href="/kontakt">
              <button className="button-green">Bezpłatna wycena</button>
            </a>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            <div
              id="chooseTransform1"
              onClick={() => handleChooseTransform(1)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/1-po.jpg"
                alt="Transformacja ogrodu nr 1 - efekt końcowy Drzewus"
              />
            </div>
            <div
              id="chooseTransform2"
              onClick={() => handleChooseTransform(2)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/2-po.jpg"
                alt="Transformacja ogrodu nr 2 - efekt końcowy Drzewus"
              />
            </div>
            <div
              id="chooseTransform3"
              onClick={() => handleChooseTransform(3)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/3-po.jpg"
                alt="Transformacja ogrodu nr 3 - efekt końcowy Drzewus"
              />
            </div>
            <div
              id="chooseTransform4"
              onClick={() => handleChooseTransform(4)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/4-po-scaled.jpg"
                alt="Transformacja ogrodu nr 4 - efekt końcowy Drzewus"
              />
            </div>
          </div>
          <div className="">
            <div
              className={`w-full ${activeTransform === 1 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/1-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/1-po.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[350px] lg:h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 2 ? "block" : "hidden"}`}
              id="transform2"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/2-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/2-po.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[350px] lg:h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 3 ? "block" : "hidden"}`}
              id="transform3"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/3-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/3-po.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[350px] lg:h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 4 ? "block" : "hidden"}`}
              id="transform4"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/4-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/4-po-scaled.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[350px] lg:h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Transform;
